const EventBus = window.EventBus;

export const NewToggleList = {
  //html
  template: `
    <div class="relative search-dropdown" @click.stop="display(component)" >

        <div class="flex content-between w-full h-10 border-b border-light pr-2 title-section__search-dropdown"
             role="button"
             tabindex="0"
             :aria-expanded="show ? 'true' : 'false'"
             :aria-controls="'lbx-filter-' + component"
             :aria-disabled="disabled ? 'true' : null"
             @keydown.enter.prevent.stop="display(component)"
             @keydown.space.prevent.stop="display(component)">
            <div @click.stop="display(component)" :class="['flex overflow-hidden items-center w-full text-sm font-normal text-left cursor-pointer title__title-section', {'text-darkGrey lbx-search-dropdown-disabled': disabled, 'text-dark lbx-search-dropdown-enabled': !disabled}]">
                {{this.title}}
            </div>
            <div v-show="!show" @click.stop="display(component)" class="flex justify-center items-center w-3 cursor-pointer list-off__title-section">
              <svg aria-hidden="true" focusable="false" width="10" height="6" :class="['fill-current', {'text-darkGrey': disabled, 'text-dark': !disabled}]" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L6 8L12 2.09815e-06L0 0Z"/>
              </svg>
            </div>
            <div v-show="show" @click.stop="display(component)" class="flex justify-center items-center w-10 cursor-pointer list-on__title-section">
              <svg aria-hidden="true" focusable="false" width="10" height="1" viewBox="0 0 10 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.5" x2="10" y2="0.5" stroke="#414042"/>
              </svg>
            </div>
        </div>
        <transition name="fade">
            <div @click.stop="" v-if="show" :id="'lbx-filter-' + component" :class="show ? 'py-4' : ''" class=" w-full z-50 absolute flex flex-col pl-1 pr-0 bg-customGray h-auto max-h-[200px] overflow-y-auto overflow-x-hidden options-section__search-dropdown gap-y-3 shadow-md">
              <label v-for="item in items" class="leading-3 text-left uppercase custom-checkbox" >
                <span class="text-xs font-bold text_items item-checkbox">
                    {{ component=='condition' ? $t(item) : $t(item)  }}
                </span>
                <span class="value__items text-[0.65rem] leading-3">
                    {{getCount(item)}}
                </span>

                <input v-if="clickClosed=='True'"
                @change="toggle(component, item)"
                :key="item"
                @click.stop="display(component)"
                type="checkbox"
                :value="item"
                :name="item"
                :checked="original_selected.includes(item.toUpperCase())" class="clickClosed-active">

                <input v-else
                @change="toggle(component, item)"
                :key="item"
                type="checkbox"
                :value="item"
                :name="item"
                :checked="original_selected.includes(item.toUpperCase())" class="clickClosed-desactive">

                <span class="rounded-full checkmark checkmark-rounded" >
                </span>
              </label>
            </div>
        </transition>
    </div>
  `,
  data: function () {
    return {
      show: false,
      uniqueInList: null,
      theme_directory: window.theme_directory,
      selected: [],
      original_selected: [],
      loaded: false,
      enable: true,
    };
  },
  props: [
    "component",
    "title",
    "items",
    "initialSelection",
    "collapse",
    "pivot",
    "clickClosed",
    "optionsCount",
  ],
  mounted() {
    EventBus.$on("CLOSE_ALL_OPEN_COMPONENTS", () => {
      if (this.show) this.show = false;
    });
    EventBus.$on(
      "CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION",
      () => {
        this.clearSelection();
      }
    );
    EventBus.$on("NEW_TOGGLE_LIST_ABSOLUTE_ENTRY_POINT", () => { });

    // check if initialSelection has something when the component is mounted, to add the tags on first load
    if (this.initialSelection.length > 0) {
      this.initialSelection.forEach((item) => {
        this.$emit("updatetags", {
          component: this.component,
          selected: item,
          status: true,
        });
      });
    }
  },
  methods: {
    entryPoint(items) {
      items.filter((item) => {
        let replace = item
          .replace(/ /g, "-")
          .replace(/---/g, "-")
          .toLowerCase();
        let replace2 = item.replace(/ /g, "-").replace(/---/g, "-");

        if (
          this.initialSelection.includes(replace) ||
          this.initialSelection.includes(replace2)
        ) {
          if (this.component == "condition") {
            this.selected.push(this.$t(item).toUpperCase());
          } else {
            this.selected.push(item.toUpperCase());
          }
          this.original_selected.push(item.toUpperCase());
        }
      });

      this.$emit("updatechecked", {
        component: this.component,
        selected: this.original_selected,
      });
    },
    clearSelection() {
      this.selected = [];
      this.original_selected = [];
      this.$emit("updatechecked", {
        component: this.component,
        selected: this.selected,
      });
    },
    display() {    
      // Verifica si el componente ya está abierto
      if (this.show) {
        // Si está abierto, simplemente cambia su estado a cerrado
        this.show = false;
      } else {
        // Si está cerrado, emite el evento para cerrar todos los componentes
        EventBus.$emit("CLOSE_ALL_OPEN_COMPONENTS", this.component);
        // Verifica si hay elementos y si está habilitado antes de cambiar el estado a abierto
        if (this.hasItems() && this.enable) {
          this.show = true;
        }
      }
    },
    hasItems() {
      return this.items.length > 0;
    },
    toggle(component, item) {
      var enabled = true;

      if (this.original_selected.includes(item.toUpperCase())) {
        let indexSelected;
        enabled = false;

        if (this.component == "condition") {
          indexSelected = this.selected.indexOf(this.$t(item).toUpperCase());
        } else {
          indexSelected = this.selected.indexOf(item.toUpperCase());
        }

        let indexOriginalSelected = this.original_selected.indexOf(
          item.toUpperCase()
        );

        this.selected.splice(indexSelected, 1);
        this.original_selected.splice(indexOriginalSelected, 1);
      } else {
        if (this.component == "condition") {
          this.selected.push(this.$t(item).toUpperCase());
        } else {
          this.selected.push(item.toUpperCase());
        }

        this.original_selected.push(item.toUpperCase());
      }

      this.$emit("updatechecked", {
        component,
        selected: this.original_selected,
      });

      this.$emit("updatetags", {
        component,
        selected: item,
        status: enabled,
      });
    },
    log(text) {
      console.log(text);
    },
    toCapitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    getCount(item) {
      if (this.optionsCount && this.optionsCount[item])
        return `(${this.optionsCount[item]})`;
      else return "";
    },
    capitalizeItems(items) {
      var arrTwo = items;
      for (var i = 0; i < arrTwo.length; i++) {
        arrTwo[i] = arrTwo[i].toUpperCase().trim();
      }

      const filteredArray = arrTwo.filter(function (ele, pos) {
        return arrTwo.indexOf(ele) == pos;
      });
      return filteredArray;
    },
  },
  watch: {
    items(items) {
      if (!this.loaded) {
        this.entryPoint(items);
        this.loaded = true;
      }
    },
  },
  computed: {
    disabled() {
      return !this.hasItems() || !this.enable;
    },
    isResponsive() {
      return !this.disableResponsive == true;
    },
  },
};
